import wechatApi from '@/api/wechat'

const wechat={
  namespaced:true,
  actions:{
    async GetWxMenus(){
      const rep=await wechatApi.getWxMenus()
      return rep.result
    },
    async SaveAndPublic({ commit },input){
      commit
      await wechatApi.saveAndPublic(input)
    }
  }
}
export default wechat